export default class SchemaComment {
	/* @ngInject */
	constructor() {
		/** @type {string} */
		this.id = '';

		/** @type {string} */
		this.comment = '';

		/** @type {boolean} */
		this.selected = false;

		/** @type {?number} */
		this.x = null;

		/** @type {?number} */
		this.y = null;
	}

	export() {
		return {
			comment:  this.comment,
			id:       this.id,
			x:        this.x,
			y:        this.y,
		};
	}
}
